import { Injectable, Injector } from '@angular/core';
import { Project } from './models/project';
import { User } from './models/users';
import { Server } from './models/server';
import { ContextCockpit, KindBoard } from 'src/utils/enums';
import { PoNotificationService } from '@po-ui/ng-components';
import { ComponentBase } from 'src/app/shared/library/component.base';
import { Token } from './models/token';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContextApplication extends ComponentBase {

  public Project: Project = new Project();
  public Usuario: User = new User();
  public Server: Server = new Server();
  public language: string;
  public currentVision: KindBoard = KindBoard.Tarefa;
  public hiddenDashboardTaskInput: boolean[]; // 0-Tarefa - 1-Insumo
  public Token: Token = new Token();
  public ContextCockpit: ContextCockpit = ContextCockpit.Padrao;

  public get Filter(): string {
    return 'companyId=' + this.Project.companyId +
      '&projectId=' + this.Project.projectId;
  }

  public get FilterCode(): string {
    return this.Project.companyId + '/' + this.Project.projectId;
  }

  public get HasContext(): boolean {
    if (this.Project.companyId && this.Project.projectId) {
      return true;
    }
    else {
      return false;
    }
  }

  public get HasUserContext(): boolean {
    const tokenBear = sessionStorage.getItem('tokenBearer');
    if (this.Usuario.username && this.Usuario.password || tokenBear) {
      if (tokenBear) {
  
        const token = JSON.parse(tokenBear);
        this.Token = token;

        const contextUsuario = sessionStorage.getItem('contextoUsuario');
        if (contextUsuario) {
          const context = JSON.parse(contextUsuario);
          this.Usuario.username = context.usuario.userCode;
        }
      }
      return true;
    }
    else {
      return false;
    }
  }

  constructor(
    private poNotification: PoNotificationService,
    public injector: Injector) {
    super(injector);
    super.ngOnInit();
    this.GetServer();
    this.hiddenDashboardTaskInput = new Array<boolean>();
    this.hiddenResultsDashboardTaskInput();
  }

  private async GetServer(): Promise<void> {
    const jsonFile = this.urlConfig();

    // O contexto da Lib foi passado pela MDI (WinForms) ?
    if (sessionStorage.getItem('ERPAPPCONFIG')) {
      const configs = JSON.parse(sessionStorage.getItem('ERPAPPCONFIG') || '{}');
      if (configs.api_baseUrl) {
        console.log("ERP_APP_CONFIG");
        // Pega a URL da API fornecida pela Lib e ignora o arquivo "config.json"
        this.Server.apiServer = this.ValidateApiServer(configs.api_baseUrl);
        return;
      }
    }

    try {
      const retorno = await lastValueFrom(this.http.get(jsonFile));
      this.Server = this.ValidateServer(retorno);
      console.log("JSON_CONFIG");
      if (this.Server.apiServer.includes('localhost')) {
        // Vamos buscar a maquina pelo hostname, para viabilizar a configuração em ambiente multi tenancy.
        // Em ambiente dev teremos que definir o config ou configurar o https.
        // Para funcionar o HTTPs precisa de uma configuração ou seja em ambiente deve não vai funcionar
        // mas para cloud vale a pena, neste caso manter o https.
        this.Server.apiServer = `https://${location.hostname}:${location.port}`;
      }
    } catch (error) {
      console.error(`Could not load file '${jsonFile}': ${JSON.stringify(error.message)}`);
    }
  }

  private urlConfig(): string {
    return `../config/config.json`;
  }

  private ValidateServer(serverParam: any): Server {
    const server = <Server>serverParam;
    server.apiServer = this.ValidateApiServer(server.apiServer);
    return server;
  }

  private ValidateApiServer(api: string): string {
    if (api.lastIndexOf('/') === api.length) {
      return api.slice(0, -1);
    }
    else if (api.split('/').length > 3) {
      api = api.replace(/\//g, '');
      const serveritens = api.split(':');
      api = serveritens[0] + '://' + serveritens[1] + ':' + serveritens[2];
      return api;
    }
    else {
      return api;
    }
  }

  hiddenResultsDashboardTaskInput() {
    this.hiddenDashboardTaskInput[0] = true;
    this.hiddenDashboardTaskInput[1] = true;
  }

  onReceiveLiterals(): void { }
}
